// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__ygHCV","footer":"ModalUpdate_footer__3xOEs"};